import "./Grid.css";
import cn from "classnames";
import type { ComponentProps, FC } from "react";

const Grid: FC<ComponentProps<"div">> = (props) => {
  const { className, ...rest } = props;

  return <div className={cn("grid", className)} {...rest} />;
};

interface GridColProps extends ComponentProps<"div"> {
  xs: number;
}

const GridCol: FC<GridColProps> = (props) => {
  const { className, xs, ...rest } = props;

  return <div className={cn(`col-${xs}`, className)} {...rest} />;
};

const GridNamespace = Object.assign(Grid, {
  Col: GridCol,
});

export { GridNamespace as Grid };
